<div [style.background]="generateGradient()"></div>
